import { useTheme } from "@emotion/react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import React, { useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import Dropzone from "../../Components/Dropzone/Dropzone";
import { updateId1, clearId1Dirty } from "../../redux/user/userSlice";
import { API, getCredentialTypeCode } from "../../utils/http";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
function _arrayBufferToBase64(buffer) {
	var binary = "";
	var bytes = new Uint8Array(buffer);
	var len = bytes.byteLength;
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
}
export default function IdUpload(props) {
	const { handleNext, handleBack, renderControls, verifier } = props;
	const id1 = useSelector((state) => state.user.application.id1);
	const [loading, setLoading] = useState(false);
	const personalInformation = useSelector((state) => state.user.application.personalInformation);
	const { t } = useTranslation();

	const dispatch = useDispatch();
	const [error, setError] = useState({});
	const [hasChanged, setHasChanged] = useState(false);
	const clearIdFront = () => {
		const payload = {
			front: "",
		};
		dispatch(updateId1(payload));
	};
	const clearIdBack = () => {
		const payload = {
			back: "",
		};
		dispatch(updateId1(payload));
	};
	const theme = useTheme();
	const handleNextButton = () => {
		if (loading) {
			console.warn("Tried to to double click next");
			return;
		}
		if (!hasChanged && id1.front && id1.back) {
			handleNext();
			return;
		}
		console.log("verify id: ", id1);
		const errors = verifier(id1);
		console.log(errors);
		const credentialTypeCode = getCredentialTypeCode();
		if (Object.keys(errors).length == 0) {
			setLoading(true);
			API.put("application", {
				id: personalInformation.id,
				pictures: [
					{
						type: "id1",
						front: id1.front,
						back: id1.back,
					},
				],
				credentialTypeCode,
			})
				.then((r) => {
					dispatch(clearId1Dirty());
					toast.success(t("Successfully saved"));
					handleNext();
				})
				.catch((e) => {
					toast.error(t("Failed to save ID"));
				})
				.finally(() => {
					setLoading(false);
				});

			setError({});
		} else {
			setError(errors);
		}
	};

	const onDropFront = useCallback(async (acceptedFiles) => {
		setHasChanged(true);
		console.log(acceptedFiles);
		if (!acceptedFiles?.[0]) return;
		const buffer = await acceptedFiles[0].arrayBuffer();
		const payload = {
			front: `data:image/png;base64,${_arrayBufferToBase64(buffer)}`,
		};
		dispatch(updateId1(payload));
	}, []);
	const onDropBack = useCallback(async (acceptedFiles) => {
		setHasChanged(true);
		console.log(acceptedFiles);
		if (!acceptedFiles?.[0]) return;
		const buffer = await acceptedFiles[0].arrayBuffer();
		const payload = {
			back: `data:image/png;base64,${_arrayBufferToBase64(buffer)}`,
		};
		dispatch(updateId1(payload));
	}, []);
	return (
		<React.Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					{/* <Typography>
						To confirm your identity, we need to compare the picture from your identity document to a photo you will take of yourself. Do you agree to the
						following statement?
					</Typography>
					<Typography>
						I understand and consent freely that my picture will be collected and processed on behalf of Police Certs via a biometric system based on facial
						recognition technology to identify me in photographs for the purposes of verifying my identity as part of my application.
					</Typography>*/}
				</Grid>

				<Grid item xs={12}>
					<Divider></Divider>
				</Grid>
				<Grid item xs={12} sm={6} textAlign="center">
					<Dropzone
						onDrop={onDropFront}
						accept={{ "image/jpeg": [".jpeg", ".jpg"] }}
						maxFiles={1}
						clearFile={clearIdFront}
						file={id1.front}
						description={t("Upload Front")}
					/>
					<Typography
						sx={{
							display: error.front ? "block" : "none",
							color: theme.palette.error.main,
						}}
					>
						{error.front}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6} textAlign="center">
					<Dropzone
						onDrop={onDropBack}
						accept={{ "image/jpeg": [".jpeg", ".jpg"] }}
						maxFiles={1}
						clearFile={clearIdBack}
						file={id1.back}
						description={t("Upload Back")}
					/>
					<Typography
						sx={{
							display: error.back ? "block" : "none",
							color: theme.palette.error.main,
						}}
					>
						{error.back}
					</Typography>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
